import { ROUTES } from '@angular/router';
import { inject, LOCALE_ID, Provider } from '@angular/core';
import { AdminLocalizedAppRoutes } from './localized-app-routes';

/**
 * Provides the localized admin routes (depending on the active LOCALE_ID).
 * Mirrors the user app; the routes themselves come from AdminLocalizedAppRoutes.
 */
export function provideLocalizedRoutes(): Provider {
  return {
    provide: ROUTES,
    multi: true,
    useFactory: () => {
      const localeId = inject(LOCALE_ID);
      return AdminLocalizedAppRoutes(localeId);
    },
  };
}
